import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { Environment } from './environments/environment';

const env: Environment = new Environment();

if (env.isProduction()) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch((err: Error) => {
        console.error(err);
    });
